import React from 'react'
import PropTypes from 'prop-types'
import { IntlProvider } from 'react-intl'
import { APP_TRANSLATIONS_LIST } from '../../i18n'

export default function LanguageProvider({ locale, children }) {
  return (
    <IntlProvider locale={locale} messages={APP_TRANSLATIONS_LIST[locale]}>
      {children}
    </IntlProvider>
  )
}

LanguageProvider.propTypes = {
  locale: PropTypes.string.isRequired,
}
